
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.496 19.077l-.99.985a1.071 1.071 0 01-1.514 0l-8.677-8.62a1.056 1.056 0 010-1.504l8.677-8.625a1.071 1.071 0 011.514 0l.99.985c.425.421.416 1.109-.017 1.522l-5.38 5.093h12.83c.593 0 1.071.475 1.071 1.065v1.42c0 .59-.478 1.064-1.071 1.064H7.099l5.38 5.093c.437.413.446 1.1.017 1.522z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_arrow_back.svg